import { DialogTitle, IconButton, styled, TextField, Typography } from '@mui/material';

export const DialogHeader = styled(DialogTitle)({
  display: 'flex',
  alignItems: 'center',
});

export const Title = styled(Typography)({
  marginLeft: 16,
});

export const CloseButton = styled(IconButton)({
  position: 'absolute',
  right: 12,
  top: 12,
  color: 'grey',
});

export const TextFieldStyled = styled(TextField)({
  [`& fieldset`]: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
});
